import styled from "styled-components"

export const TimingSectionWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 24px;
	border-bottom: 1px solid #eaeafd;
	padding-bottom: 24px;
	.lastSection {
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		gap: 8px;
		> p {
			font-weight: 400;
			font-size: 14px;
			line-height: 16.8px;
			letter-spacing: 0%;
			margin: 0;
		}
		.containerTimingInputs {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 8px;
			> div {
				&:first-child {
					width: 80px;
				}
			}
			.middelContainer {
				flex: 1;
				background-color: #fafafa;
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 12px;
				padding: 8px;
				border-radius: 8px;
				> div {
					flex-basis: 50%;
				}
			}
		}
	}
`
